import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.ends-with";
//
//
//
//
//
//
//
//
//
//
//
//
//
import baseUrl from "../api/baseUrl";
export default {
  data: function data() {
    return {
      imageUrl: "",
      uploadURL: baseUrl + 'api/archive/upload',
      headers: {
        token: sessionStorage.getItem('token')
      }
    };
  },
  methods: {
    // 上传成功
    handleAvatarSuccess2: function handleAvatarSuccess2(res, file) {
      this.$message.success(res.data);
    },
    // 上传之前
    beforeAvatarUpload2: function beforeAvatarUpload2(file) {
      var isZip = file.type === 'application/zip' || file.type === 'application/x-rar-compressed' || file.name.endsWith('.zip') || file.name.endsWith('.rar');

      if (!isZip) {
        this.$message.error('只允许上传 ZIP 或 RAR 文件');
        return false; // 阻止文件上传
      }

      return true;
    }
  }
};